import { Pipe, PipeTransform } from '@angular/core';
import { isNil } from 'lodash';

type ValueType = boolean | Date | number | string;

@Pipe({
  name: 'empty',
  pure: true,
})
export class EmptyPipe implements PipeTransform {
  transform(value: ValueType | null | undefined, placeholder = '-'): string {
    if (isNil(value)) {
      return placeholder;
    }

    return value.toString().trim() || placeholder;
  }
}
